import { styled } from "@mui/material";

const Bold = styled("b")(({ theme }) => ({
  fontSize: "inherit",
  lineHeight: "inherit",
  fontWeight: theme.typography.fontWeightMedium,
}));

export type BoldProps = typeof Bold extends (props: infer P) => any ? P : never;

export default Bold;
